import { render, staticRenderFns } from "./ReloginOnFly.vue?vue&type=template&id=20983f7e&"
import script from "./ReloginOnFly.vue?vue&type=script&lang=js&"
export * from "./ReloginOnFly.vue?vue&type=script&lang=js&"
import style0 from "./ReloginOnFly.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports